//import { CartUpdateEvent } from '@theme/events';

const sizeToShortValueMap = {
  'xxsmall' : 'XXS', 'xsmall' : 'XS', 'small' : 'S', 'medium' : 'M', 'large' : 'L', 'xlarge' : 'XL', 'xxlarge' : 'XXL', 'xxxlarge' : 'XXXL', 'non sized' : 'One Size'
}

function initializeQuickView() {
  const quickViewModalEl = document.querySelector('.quick-view-modal');
  if (!quickViewModalEl || quickViewModalEl.length === 0) {
    const modal = createQuickViewModal();
    document.body.appendChild(modal);
  }

  document.querySelectorAll('[data-quick-view]').forEach(button => {
    button.addEventListener('click', async () => {
      const handle = button.getAttribute('data-product-handle');
      const discountTags = button.getAttribute('data-discount-tags');
      const productTitle = button.getAttribute('data-product-title');
      const productPrice = button.getAttribute('data-price');
      const productImage = button.getAttribute('data-image');      
      window.GTMEventBus.publish(eventConstants.QUICK_VIEW, {productTitle, productPrice, productImage});
      const product = await fetchProduct(handle);
      renderQuickViewModal(product, discountTags);
      openModal();
      // window.GTMEventBus.publish(eventConstants.VIEW_ITEM, {product, selectedVariant});
    });
  });
}

let currentProduct = null;
let selectedVariant = null;
let selectedOptions = {};

async function fetchProduct(handle) {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) throw new Error(`Failed to load ${handle}`);
  return await res.json();
}

function createQuickViewModal() {
  const wrapper = document.createElement('div');
  wrapper.className = 'quick-view-modal fixed inset-0 bg-black/50 display_none z-50 flex items-baseline lg:items-center justify-right lg:justify-center';
  wrapper.innerHTML = `
    <div class="quick-view-content bg-white max-w-[860px] pt-4 p-1 sm:p-4 relative overflow-y-auto h-full lg:h-auto lg:max-h-[80vh] w-[80%]">
      <button class="quick-view-close absolute top-4 right-4 text-gray-600 hover:text-black text-2xl">&times;</button>
      <div class="px-4 pb-8 grid grid-cols-1 lg:grid-cols-2">
        <div class="quick-view-media pt-8 lg:pt-4 lg:pr-[60px] flex flex-col">
          <div class="main-image relative mb-4">
            <img src="" alt="Main Image" class="w-full h-auto object-cover" id="quick-view-main-img" />
          </div>
          <div class="thumbnail-carousel relative flex items-center gap-2">
            <button class="thumb-prev h-full px-1 bg-white">
              <svg class="h-5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 4L8 12L16 20" stroke="#171011" stroke-width="1.5"></path></svg>
            </button>
            <div class="thumbnail-list-wrapper overflow-hidden h-[64px] flex-1">
              <div class="thumbnail-list flex transition-transform duration-300 ease-in-out"></div>
            </div>
            <button class="thumb-next h-full px-1 bg-white">
              <svg class="h-5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99976 20L15.9998 12L7.99976 3.99995" stroke="#171011" stroke-width="1.5"></path></svg>
            </button>
          </div>
        </div>
      
        <div class="quick-view-info pt-8 md:pt-4">
          <h1 class="font-medium text-[16px]/[20px] lg:text-[25px]/[25px] mb-2" style="letter-spacing: .02em;"
            id="quick-view-title"></h1>
          <div class="mb-5">
            <span class="line-through text-sm opacity-[0.4]" id="quick-view-compare"></span>
            <span class="text-sm ml-1" id="quick-view-price"></span>
          </div>
          <!--<div id="discount-tags" class="w-full lg:w-auto inline-block text-[12px] lg:text-[10px] bg-[#E6E5E5] text-cocoa px-3 py-3 mb-3 lg:px-1 lg:py-[2px] rounded-sm mt-3 lg:mt-0 order-4 display_none" 
          style="letter-spacing: .02em; line-height: 15px; font-weight: 600;"> 
          </div>-->
          <div class="mb-7" id="quick-view-options"></div>
          <button id="quick-view-add-btn" class="w-full bg-black text-white py-3 text-center uppercase hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed">
            Add to Bag
          </button>
          <div class="product__discount-code text-center mt-6 display_none"></div>
          <div class="mt-6 pt-5 border-t border-dusty underline">
            <button class="view_product_link text-sm font-semibold underline uppercase">
              View All Product Details
            </button>
          </div>
        </div>
      </div>  
    </div>
  `;

  wrapper.querySelector('.view_product_link').addEventListener('click', () => window.location.href = currentProduct?.url)
  wrapper.querySelector('.quick-view-close').addEventListener('click', closeModal);
  wrapper.addEventListener('click', (e) => {
    if (e.target === wrapper) closeModal(e);
  });
  return wrapper;
}

const formatMoney = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount / 100);
};
let colorOptionIdx = 0;
let sizeOptionIdx = 0;
let colorSizeToVariantMap = {};
let colorToAvailableSizes = {};
let sizeToAvailableColors = {};
let unavailableColors = [];
let unavailableSizes = [];
// const colorToSwatchImage = {};
function generateColorSizeMaps(product) {
  colorOptionIdx = product?.options.filter(option => option.name === 'color')?.[0]?.position;
  sizeOptionIdx = product?.options.filter(option => option.name === 'size')?.[0]?.position;  
  product.variants.forEach(v => {
    const colorWithFamily = v[`option${colorOptionIdx}`];
    const size = v[`option${sizeOptionIdx}`];
    if (v.available) {
      colorSizeToVariantMap[`${colorWithFamily} - ${size}`] = v.id;
      if (!colorToAvailableSizes.hasOwnProperty(colorWithFamily)) {
        colorToAvailableSizes[colorWithFamily] = [];
      }
      if (!colorToAvailableSizes[colorWithFamily].includes(size)) {
        colorToAvailableSizes[colorWithFamily].push(size);
      }
      if (!sizeToAvailableColors.hasOwnProperty(size)) {
        sizeToAvailableColors[size] = [];
      }
      if (!sizeToAvailableColors[size].includes(colorWithFamily)) {
        sizeToAvailableColors[size].push(colorWithFamily);
      }
    } else {
      if (!unavailableColors.includes(colorWithFamily)) unavailableColors.push(colorWithFamily);
      if (!unavailableSizes.includes(size)) unavailableSizes.push(size);
    }
  });
  const availableColors = Object.keys(colorToAvailableSizes);
  const availableSizes = Object.keys(sizeToAvailableColors);
  unavailableColors = unavailableColors.filter(color => !availableColors.includes(color));
  unavailableSizes = unavailableSizes.filter(size => !availableSizes.includes(size));
  console.log('done');
}

function renderQuickViewModal(product, discountTags) {
  colorSizeToVariantMap = {};
  colorToAvailableSizes = {};
  sizeToAvailableColors = {};
  unavailableColors = [];
  unavailableSizes = [];

  currentProduct = product;
  generateColorSizeMaps(product);
  selectedOptions = {};
  const colorSwatchMap = {};
  const mainImg = document.getElementById('quick-view-main-img');
  const thumbnails = document.querySelector('.thumbnail-list');
  const thumbPrev = document.querySelector('.thumb-prev');
  const thumbNext = document.querySelector('.thumb-next');
  const titleEl = document.getElementById('quick-view-title');
  const compareEl = document.getElementById('quick-view-compare');
  const priceEl = document.getElementById('quick-view-price');
  const discountTagsEl = document.querySelector('.product__discount-code');
  const optionsEl = document.getElementById('quick-view-options');
  const addBtn = document.getElementById('quick-view-add-btn');

  titleEl.textContent = product.title;
  priceEl.textContent = formatMoney(product.price);
  compareEl.textContent = product.compare_at_price ? formatMoney(product.compare_at_price) : '';

  if (discountTags?.trim()) {
    const discountTagsStr = discountTags.replaceAll(',', '<br>');
    discountTagsEl.innerHTML = discountTagsStr;
    discountTagsEl.classList.remove('display_none');
  }
  // ==================================================
  // Helper functions for availability
  // ==================================================
  /* const getAvailableOptions = (optionIndex, value) => {
    return product.variants.filter(v => v.available && v.options[optionIndex] === value);
  };

  const isVariantAvailable = (colorValue, sizeValue) => {
    return product.variants.some(v => 
      v.options[colorOptionIdx] === colorValue &&
      v.options[sizeOptionIdx] === sizeValue &&
      v.available
    );
  }; */

  // ==================================================
  // Render Thumbnails Carousel
  // ==================================================
  thumbnails.innerHTML = '';
  let thumbIndex = 0;
  const visibleThumbs = 4;
  // const thumbGap = 8;
  const thumbHeight = 64;
  const colorThumbnailIndices = {};

  const updateThumbs = () => {
    const total = product.images.length;
    const thumbnailElem = thumbnails.children[thumbIndex];
    const thumbWidth = thumbnailElem?.offsetWidth || 64;
    const computedStyle = window.getComputedStyle(thumbnailElem);
    const marginLeft = parseFloat(computedStyle.marginLeft);
    const marginRight = parseFloat(computedStyle.marginRight);
    const offset = -thumbIndex * (thumbWidth + marginLeft + marginRight);
    thumbnails.style.transform = `translateX(${offset}px)`;
    thumbPrev.classList.toggle('opacity-25', thumbIndex === 0);
    thumbNext.classList.toggle('opacity-25', thumbIndex >= (total - visibleThumbs - 1));
  };

  if (product.images.length > 0) {
    mainImg.src = product.images[0];
    let mediaCounter = 0;
    product.media.forEach((media, idx) => {
      if (media.alt.startsWith('#swatch')) {
        colorSwatchMap[media.alt] = media.src;
      } else {
        const img = media.src;
        const thumb = document.createElement('img');
        thumb.src = img;
        thumb.className = `h-full mx-2 w-auto object-cover cursor-pointer border border-transparent hover:border-black flex-shrink-0`;
        thumb.style.height = `${thumbHeight}px`;
        thumb.addEventListener('click', () => {
          mainImg.src = img;
          document.querySelectorAll('.thumbnail-list img').forEach(el => el.classList.remove('border-black'));
          thumb.classList.remove('border-transparent');
          thumb.classList.add('border-black');
        });
        // if (idx === 0) {
        //   thumb.classList.remove('border-transparent');
        //   thumb.classList.add('border-black');
        // }
        if (!colorThumbnailIndices.hasOwnProperty(media.alt)) {
          colorThumbnailIndices[media.alt] = [];
        }
        colorThumbnailIndices[media.alt].push(mediaCounter);
        thumbnails.appendChild(thumb);
        mediaCounter++;
      }
    });

    // const updateThumbs = () => {
    //   const total = product.images.length;
    //   const thumbWidth = thumbnails.children[0]?.offsetWidth || 64;
    //   const offset = -thumbIndex * (thumbWidth + thumbGap);
    //   thumbnails.style.transform = `translateX(${offset}px)`;
    //   thumbPrev.classList.toggle('opacity-25', thumbIndex === 0);
    //   thumbNext.classList.toggle('opacity-25', thumbIndex >= (total - visibleThumbs - 1));
    // };

    thumbPrev.addEventListener('click', () => {
      if (thumbIndex > 0) {
        thumbIndex--;
        updateThumbs();
      }
    });

    thumbNext.addEventListener('click', () => {
      if (thumbIndex < product.images.length - visibleThumbs) {
        thumbIndex++;
        updateThumbs();
      }
    });

    setTimeout(updateThumbs, 50);
  }

  // ==================================================
  // Render Color and Size Options with stock logic
  // ==================================================
  optionsEl.innerHTML = '';
  let colorWrapper, sizeWrapper;
  let colorValuesDiv, sizeValuesDiv;
  let selectedColor = null;
  let selectedSize = null;

  product.options.forEach((option, optionIndex) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'mb-6';
    const label = document.createElement('legend');
    label.innerHTML = `${option.name}<span class="pl-2"></span>`;
    label.className = `${option.name.toLowerCase()} option_label uppercase block mb-2 font-semibold text-xs sm:text-sm`;
    label.style = 'letter-spacing: .02em';
    wrapper.appendChild(label);

    const valuesDiv = document.createElement('div');
    
    if (option.name.toLowerCase().includes('color')) {
      // valuesDiv.className = 'color-swatch-wrapper';
      // colorOptionIdx = optionIndex;
      colorWrapper = wrapper;
      colorValuesDiv = valuesDiv;

      option.values.forEach(value => {
        if (unavailableColors?.includes(value)) return; // skip fully unavailable color
        
        const btn = document.createElement('button');
        btn.className = 'color-swatch rounded-full mr-2 border border-cocoa p-[2px]';
        btn.style.backgroundColor = value.toLowerCase();
        btn.dataset.value = value;
        let colorNameFamilyArr = value?.split(" - ");
        const colorName = (colorNameFamilyArr && colorNameFamilyArr.length > 1 ? colorNameFamilyArr[1].toUpperCase() : value.toUpperCase());
        const swatchImage = colorSwatchMap[`#swatch_${colorName}`]
        btn.innerHTML = `<img class="rounded-full border h-[30px] w-[30px]" src="${swatchImage}" width="30" height="30" alt="${colorName}" loading="lazy" decoding="async">`;

        btn.addEventListener('click', () => {
          colorValuesDiv.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedColor = value;
          selectedOptions[colorOptionIdx] = value;
          updateSizeAvailability();
          updateSelectedVariant();
          updateMainImageForColor(colorName);
        });

        valuesDiv.appendChild(btn);
      });

      optionsEl.prepend(wrapper);
      wrapper.appendChild(valuesDiv);

    } else if (option.name.toLowerCase().includes('size')) {
      valuesDiv.className = 'size-wrapper';
      // sizeOptionIdx = optionIndex;
      sizeWrapper = wrapper;
      sizeValuesDiv = valuesDiv;

      option.values.forEach(value => {
        // if (unavailableSizes?.includes(value)) return; // skip fully unavailable size

        const btn = document.createElement('button');
        btn.className = 'size mb-[10px] cursor-pointer';
        const sizeShortValue = sizeToShortValueMap.hasOwnProperty(value.toLowerCase()) ? sizeToShortValueMap[value.toLowerCase()] : value;
        btn.textContent = sizeShortValue;
        btn.dataset.value = value;

        btn.addEventListener('click', () => {
          sizeValuesDiv.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedSize = value;
          selectedOptions[sizeOptionIdx] = value;
          updateColorAvailability();
          updateSelectedVariant();
        });

        valuesDiv.appendChild(btn);
      });
      
      optionsEl.appendChild(wrapper);
      wrapper.appendChild(valuesDiv);
    }
  });
  
  // ==================================================
  // Helper: Update unavailable for sizes when color selected
  // ==================================================
  function updateSizeAvailability() {
    if (!sizeValuesDiv || !selectedColor) return;
    const availableSizes = colorToAvailableSizes?.[selectedColor];
    sizeValuesDiv.querySelectorAll('button').forEach(btn => {
      const sizeValue = btn.dataset.value;
      const available = availableSizes?.includes(sizeValue); // isVariantAvailable(selectedColor, sizeValue);
      if (!available) {
        btn.classList.add('unavailable');
        // btn.disabled = true;
      } else {
        btn.classList.remove('unavailable');
        // btn.disabled = false;
      }
    });
  }

  // ==================================================
  // Helper: Update unavailable for colors when size selected
  // ==================================================
  function updateColorAvailability() {
    if (!colorValuesDiv || !selectedSize) return;
    const availableColors = sizeToAvailableColors?.[selectedSize];
    colorValuesDiv.querySelectorAll('button').forEach(btn => {
      const colorValue = btn.dataset.value;
      const available = availableColors?.includes(colorValue); // isVariantAvailable(colorValue, selectedSize);
      if (!available) {
        btn.classList.add('unavailable');
        // btn.disabled = true;
      } else {
        btn.classList.remove('unavailable');
        // btn.disabled = false;
      }
    });
  }

  // ==================================================
  // Helper: Select default first available color & size
  // ==================================================
  let firstColorBtn = [...colorValuesDiv.querySelectorAll('button')].find(b => !b.classList?.contains('unavailable'));
  if (!firstColorBtn) {
    firstColorBtn = colorValuesDiv.querySelector('button')
  }
  if (firstColorBtn) {
    firstColorBtn.click(); // selects first color and triggers update
    const firstAvailableSize = [...sizeValuesDiv.querySelectorAll('button')].find(b => !b.classList?.contains('unavailable'));
    if (firstAvailableSize) {
      firstAvailableSize.click(); // selects first size for that color
    }
  }

  // ==================================================
  // Helper: Update main image for color selection
  // ==================================================
  function updateMainImageForColor(color) {
    const colorKey = `#color_${color}`;
    const thumbnailIndices = colorThumbnailIndices[colorKey];
    if (thumbnailIndices?.length && !thumbnailIndices.includes(thumbIndex)) {
      thumbIndex = thumbnailIndices[0];
      thumbnails.children[thumbIndex].click();
      updateThumbs();
      return; 
    }
    // Optional logic: if your images are tagged or named with color
    // const colorImage = product.images.find(img => img.toLowerCase().includes(color.toLowerCase()));
    // if (colorImage) {
    //   mainImg.src = colorImage;
    //   document.querySelectorAll('.thumbnail-list img').forEach(imgEl => {
    //     imgEl.classList.toggle('border-black', imgEl.src.includes(colorImage));
    //   });
    // } else {
    //   mainImg.src = product.images[0];
    // }
  }

  // addBtn.disabled = true;
  addBtn.onclick = handleAddToCart;
}

function updateSelectedVariant() {
  const addBtn = document.getElementById('quick-view-add-btn');
  const selectedOptionKeys = Object.keys(selectedOptions);
  if (selectedOptionKeys?.length < 2) {
    addBtn.disabled = true;
    return;
  }
  
  const priceEl = document.getElementById('quick-view-price');
  const compareEl = document.getElementById('quick-view-compare');

  // const selectedOptionsKeys = Object.values(selectedOptions);
  // if (selectedValues.length !== currentProduct.options.length) {
  //   addBtn.disabled = true;
  //   return;
  // }

  const matchingVariants = currentProduct.variants.filter(v =>
    v[`option${colorOptionIdx}`] === selectedOptions[colorOptionIdx] &&
    v[`option${sizeOptionIdx}`] === selectedOptions[sizeOptionIdx] 
  );

  const availableVariant = matchingVariants.find(v => v.available) 
  const matchingVariant = availableVariant || matchingVariants?.[0];
  selectedVariant = matchingVariant;
  window.GTMEventBus.publish(eventConstants.VIEW_ITEM, {product: currentProduct, selectedVariant});
  const colorLabel = document.querySelector('.quick-view-modal legend.color span');
  const sizeLabel = document.querySelector('.quick-view-modal legend.size span');
  let colorNameFamilyArr = selectedOptions[colorOptionIdx]?.split(" - ");
  const colorName = (colorNameFamilyArr && colorNameFamilyArr.length > 1 ? colorNameFamilyArr[1].toUpperCase() : value.toUpperCase());
  colorLabel.textContent = `${colorName}`;
  sizeLabel.textContent = `${selectedOptions[sizeOptionIdx]}`; 

  if (matchingVariant) {
    addBtn.disabled = !matchingVariant.available;
    addBtn.textContent = matchingVariant.available ? "Add To Bag" : "Out Of Stock";
    addBtn.dataset.variantId = matchingVariant.id;
    priceEl.textContent = formatMoney(matchingVariant.price);
    compareEl.textContent = matchingVariant.compare_at_price
      ? formatMoney(matchingVariant.compare_at_price)
      : '';
  } else {
    addBtn.disabled = true;
  }
}

function updateCartDrawer() {
  const currentTime = Date.now();
  import('@theme/events').then(({ CartUpdateEvent }) => {
      const cartDrawer = document.querySelector('cart-drawer-component');    
      fetch(`/cart.js?${currentTime}`)
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart?.item_count + 1;
        const event = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'fad-refresh',
          sections: {}
        });
        document.dispatchEvent(event);
        // if (cartDrawer?.hasAttribute('auto-open')) {
        setTimeout(() => {
          closeModal();
          cartDrawer.open();
          window.GTMEventBus.publish(eventConstants.VIEW_CART, {cart});
        }, 200);
        // }
      });
    });
}

async function handleAddToCart() {
  const addToCartBtn = document.getElementById('quick-view-add-btn');
  const variantId = addToCartBtn.dataset.variantId;
  if (!variantId) return;

  const resp = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  addToCartBtn.textContent = 'Added'; 
  window.GTMEventBus.publish(eventConstants.ADD_TO_CART, {product: currentProduct, selectedVariant});
  updateCartDrawer();
  // closeModal();
}

function openModal() {
  document.querySelector('.quick-view-modal').classList.remove('display_none');
  document.body.style.overflow = 'hidden';
}

function closeModal(e) {
  if (e) {
    e.preventDefault();
  }
  document.querySelector('.quick-view-modal').classList.add('display_none');
  document.body.style.overflow = '';
}
